<template>
  <div>
    <OrganismsGsdBar :vertical="vertical" />

    <V2OrganismHeroSection
      title="COMPARE LIFE INSURANCE"
      description="There are thousands of people named Meena in Australia right now, but only one is saving over $10,000 on her life insurance premium - after a 15-minute chat with Sam, one of our life insurance comparison experts."
      image="/images/hero/life-insurance.png"
      primary-btn-label="Compare now"
      :to="verticalData?.formPage"
      :has-secondary-btn="false"
    />

    <V2MoleculesReviews size="large" inverted />

    <V2OrganismHomeCompanyComparison
      :assets-base-url="`/icons/life-insurance/company-logos/`"
      :companies="PARTNER_ITEMS"
      :card-width="105"
      more-button-url="/life-insurance/companies/"
      class="!bg-semantic-surface-container-low"
    >
      <template #header> Our life insurance partners </template>
      <template #sub-header>
        We work with a wide range of leading insurance providers. Unfortunately
        some funds choose not to be listed, but we'll still help you find the
        best value from those who are.
      </template>
    </V2OrganismHomeCompanyComparison>

    <V2OrganismHomeGreatDeal
      :cards="GREAT_DEAL_ITEMS_V2"
      :col-count="devices.width.value < 768 ? 1 : 2"
      class="!bg-semantic-surface-container-lowest"
    >
      <template #header>
        <p>What is life insurance?</p>
      </template>

      <template #sub-header>
        Life insurance is your protection for grown up problems, offering you -
        and your loved ones - financial protection during significant life
        events, during your life (living cover) or after your death (life
        cover).
      </template>
    </V2OrganismHomeGreatDeal>

    <V2OrganismHomeTableTabs
      class="!bg-semantic-surface-default"
      :tabs="[
        {
          label: 'Retail life insurance',
          key: 'retail-life-insurance',
        },
        {
          label: 'Default life in super',
          key: 'default-life-in-super',
        },
      ]"
      :list="WHY_GET_LIFE_INSURANCE"
      :title="{
        'Retail life insurance': 'Life Insurance VS Default Life in Super',
        'Default life in super': 'Life Insurance VS Default Life in Super',
      }"
      :sub-header="{
        'Retail life insurance': `Did you know you might have default life insurance via your superannuation? <br class='hidden lg:block' />There are benefits to having retail life insurance & default life in super. <br class='hidden lg:block' />Here are some of the differences:`,
        'Default life in super': `Did you know you might have default life insurance via your superannuation? <br class='hidden lg:block' />There are benefits to having retail life insurance & default life in super. <br class='hidden lg:block' />Here are some of the differences:`,
      }"
    />

    <V2OrganismHomeGreatDeal
      :cards="SAVING_PLAN_ITEMS_V2"
      :col-count="devices.width.value < 768 ? 1 : 2"
      class="!bg-semantic-surface-container-lowest"
    >
      <template #header>
        <p>Why life insurance is important?</p>
      </template>
    </V2OrganismHomeGreatDeal>

    <V2OrganismHomeComparisonTableTabs
      :layout="devices.isMobile.value ? 'two-table' : 'table'"
      title="How much do life insurance premiums cost?"
      table-title="Premium Cost By Gender"
      description="*Costs are based on policies for an average, non-smoker, white collar worker on an $80k salary <br class='hidden md:block' />with no pre-existing conditions"
      :costs="COMPARISON_TABLE_DATA"
      :tabs="['$1 Million Cover', '$2 Million Cover']"
      bg-class="bg-semantic-surface-default"
      wrapper-class="!max-w-wrapper-md"
      footer="<span>Quotes correct as of </span> 23/09/23 - subject to expiry"
    />

    <V2OrganismHomeSiteLinks
      class="!bg-semantic-surface-container-lowest"
      :items="SITE_LINKS"
    >
      <template #header> Learn more about life insurance </template>
    </V2OrganismHomeSiteLinks>

    <V2MoleculesReviews
      layout="reviews"
      size="base"
      class="bg-semantic-surface-container-low"
    >
      <template #header> How we’ve helped Australians like you. </template>
    </V2MoleculesReviews>

    <V2OrganismFaq
      id="glossary"
      class="bg-semantic-surface-container-lowest"
      title="A glossary of life insurance terms"
      :list="GLOSSSARY_LIST"
    >
      Life insurance can be complicated. Below are some of the key terms you may
      see when comparing life insurance
    </V2OrganismFaq>

    <V2OrganismFaq
      id="faq"
      title="Life Insurance FAQs"
      :list="FAQ_ITEMS"
    >
      Common questions about comparing life insurance. Here are some of the most
      frequently asked questions we receive about life insurance:
    </V2OrganismFaq>

    <div class="bg-semantic-surface-container-lowest py-10 md:py-20 px-4">
      <V2MoleculesCardExpertCard
        image="images/authors/rebrand/mathew-lang.png"
        :bordered="false"
      >
        <template #title>
          <span class="font-semibold"
          >Meet our General Manager of Life Insurance, Matthew Lang
          </span>
        </template>

        <template #description>
          Matthew Lang is the general manager of life insurance at Compare Club.
          Matthew leads a team of dedicated professionals who are passionate
          about helping individuals and families make informed decisions about
          their life insurance needs. Whether it's finding the right coverage
          for your specific circumstances, comparing policies, or optimizing
          your existing policy, Matthew and his team are here to provide expert
          guidance and support.
        </template>
      </V2MoleculesCardExpertCard>
    </div>

    <V2OrganismHomeGuideTiles
      class="!bg-semantic-surface-container-low"
      :action-button-url="VERTICALS[vertical].guidesUrl"
      :guides="GUIDES_ITEMS"
      image-lazy-load
    >
      <template #header>
        All your life insurance questions answered with our in depth guides
      </template>
    </V2OrganismHomeGuideTiles>

    <V2MoleculesCardDisclaimerCard
      class="bg-semantic-surface-container-lowest"
      :bordered="false"
    >
      <template #title> Things you should know </template>
      <template #description>
        <p>
          Advizer Pty Ltd ABN 83 168 993 333 of 201 Sussex Street, Sydney,
          trading as Life Insurance Comparison, owns and operates
          LifeinsuranceComparison.com.au and its associated website. Advizer Pty
          Ltd is an authorised representative of Alternative Media Pty Ltd (AFSL
          486326) and fully owned subsidary of Compare Club Group.
        </p>
      </template>
    </V2MoleculesCardDisclaimerCard>
  </div>
</template>

<script setup>
import {
  GREAT_DEAL_ITEMS_V2,
  GUIDES_ITEMS,
  FAQ_ITEMS,
  SITE_LINKS,
  GLOSSSARY_LIST,
  COMPARISON_TABLE_DATA,
  PARTNER_ITEMS,
  SAVING_PLAN_ITEMS_V2,
  WHY_GET_LIFE_INSURANCE
} from '~/constants/pages/life-insurance'

const { devices } = deviceChecker()
const $route = useRoute()

const trustpilotStore = useTrustpilotStore()

const vertical = VERTICAL.LIFE_INSURANCE
const verticalData = VERTICALS[vertical]

defineOptions({
  name: 'LifeInsurance'
})

const PAGE_DETAILS = {
  title: 'Life Insurance Comparison Australia | Compare Club',
  description: 'Compare life insurance policies and save. Get a free quote from a licensed life insurer broker, all in one place. Click here to compare',
  ogDescription: 'Compare life insurance policies and save. Get a free quote from a licensed life insurer broker, all in one place',
  ogUrl: trailingSlash(`${CC_DOMAIN}${$route.path}`),
  ogType: 'product'
}

generateMeta({
  title: PAGE_DETAILS.title,
  ogTitle: PAGE_DETAILS.title,
  description: PAGE_DETAILS.description,
  ogDescription: PAGE_DETAILS.ogDescription,
  ogUrl: PAGE_DETAILS.ogUrl,
  ogType: PAGE_DETAILS.ogType
}, pageIsFunnel($route))

useJsonld(() => {
  const _path = trailingSlash($route.path)

  const {
    trustScore,
    numberOfReviews
  } = trustpilotStore.trustpilotData ?? {}

  return {
    '@context': 'https://schema.org',
    '@graph': [
      GENERATE_WEBPAGE_SCHEMA({
        page: _path,
        pageTitle: PAGE_DETAILS.title,
        pageDescription: PAGE_DETAILS.description,
        aboutPath: `${_path}#service`,
        mainEntityPath: `${_path}#service`,
        primaryImageOfPagePath: '/#logo',
        breadcrumbPath: `${_path}#breadcrumb`
      }),
      GENERATE_SERVICE_SCHEMA({
        page: _path,
        name: 'Life Insurance Comparison',
        serviceType: 'Insurance comparison',
        description: 'Compare life insurance in Australia with Compare Club. Quickly filter hundreds of policies to find the cover you need.',
        audienceName: 'Australian consumers comparing life insurance',
        servicePhone: '+611300757819',
        trustpilot: {
          rating: trustScore,
          count: numberOfReviews?.total
        }
      }),
      GENERATE_BREADCRUMB_SCHEMA(_path)
    ]
  }
})
</script>
